import AdviceStatus from 'types/AdviceStatus';
import SelfServiceStatus from 'modules/selfServices/types/SelfServiceStatus';
import { SelfService, SelfServiceOrigin, SelfServiceType } from 'modules/selfServices/types/SelfService';

import { getProactiveWorks } from 'modules/selfServices/utils';

export const RedirectPathConfig = {
  [SelfServiceType.CHECK_IN]: '/checkin',
  [SelfServiceType.CHECK_OUT]: '/checkout',
  [SelfServiceType.BREAKDOWN]: '/breakdown',
};

export const canSkipAlreadyAnsweredSteps = (selfService: SelfService): boolean => {
  const { origin, type, originContext } = selfService;
  const isAnswered = originContext[origin]?.status === SelfServiceStatus.ANSWERED;
  const hasHomeAnswered = originContext.HOME?.status === SelfServiceStatus.ANSWERED;
  const proactiveWorks = getProactiveWorks(selfService);
  const hasPendingProactiveWorks = proactiveWorks.some((proactiveWork) => proactiveWork.status === AdviceStatus.PENDING);


  return (
    !isAnswered
    && !hasPendingProactiveWorks
    && hasHomeAnswered
    && type === SelfServiceType.CHECK_IN
  );
};

export const shouldOpenFlowTypeModal = (selfService: SelfService) => {
  const isAnswered = selfService.originContext[selfService.origin]?.status === SelfServiceStatus.ANSWERED;
  const hasHomeAnswered = selfService.originContext.HOME?.status === SelfServiceStatus.ANSWERED;
  const hasAdditionalCustomer = Boolean(selfService.additionalCustomer);
  return (
    !hasAdditionalCustomer
    && selfService.dealer?.allowQuickCheckIn
    && selfService.type === SelfServiceType.CHECK_IN
    && (selfService.origin === SelfServiceOrigin.KIOSK || selfService.origin === SelfServiceOrigin.ON_SITE)
    && !hasHomeAnswered
    && !isAnswered
  );
};